<template>
  <div class="container-fluid px-5 mt-4">

    <!-- Nadpis + akční tlačítka -->
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h1 class="credits-page__title">{{ $t('client.myProfile') }}</h1>
      <div class="d-flex gap-2">
        <button class="btn cert-list__view-btn" @click="togglePasswordModal()">
          {{ $t('client.passwordChange') }}<i class="bi bi-lock-fill ms-1"></i>
        </button>
        <button class="btn cert-list__view-btn d-none">
          <i class="bi bi-moon-fill me-1"></i>Switch Theme
        </button>
        <button class="btn cert-list__view-btn d-none">
          <i class="bi bi-globe2 me-1"></i>Switch Language
        </button>
      </div>
    </div>

    <Skeletor v-if="isLoading" />

    <div v-if="!isLoading">

      <!-- Sekce: Contact -->
      <div class="dashboard-section-header mb-3 mt-5">
        <div class="d-flex align-items-center gap-2">
          <img :src="iconEnvelope" alt="" class="dashboard-section-header__icon" style="width:14px;height:14px;filter:brightness(0) invert(88%) sepia(6%) saturate(362%) hue-rotate(202deg) brightness(93%) contrast(87%)">
          <span class="dashboard-section-header__title">{{ $t('general.contact') }}</span>
        </div>
        <button class="profile-edit-btn" @click="toggleModal">
          {{ $t('general.edit') }}<i class="bi bi-pencil-fill ms-1"></i>
        </button>
      </div>

      <div class="cert-list__row cert-detail__info-row mb-5">
        <div class="cert-list__icon-wrap">
          <div class="profile-initials-avatar">{{ initials }}</div>
        </div>
        <div class="profile-contact-info">
          <span class="profile-contact-name">{{ client.name || '—' }}</span>
          <span class="profile-contact-email">{{ client.email || '—' }}</span>
        </div>
      </div>

      <div class="row g-4 mb-5">

        <!-- Sekce: Adresa -->
        <div class="col-12 col-lg-6">
          <div class="dashboard-section-header mb-3">
            <div class="d-flex align-items-center gap-2">
              <img :src="iconHome" alt="" class="dashboard-section-header__icon">
              <span class="dashboard-section-header__title">{{ $t('client.address') }}</span>
            </div>
            <button class="profile-edit-btn" @click="toggleAddressModal">
              {{ $t('general.edit') }}<i class="bi bi-pencil-fill ms-1"></i>
            </button>
          </div>
          <div class="profile-data-card">
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.line1') }}</span>
              <span class="cert-list__value">{{ client.address?.line_1 || '—' }}</span>
            </div>
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.city') }}</span>
              <span class="cert-list__value">{{ client.address?.city || '—' }}</span>
            </div>
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.postalCode') }}</span>
              <span class="cert-list__value">{{ client.address?.postal_code || '—' }}</span>
            </div>
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.countryCode') }}</span>
              <span class="cert-list__value d-flex align-items-center gap-2">
                <span v-if="client.address?.country_code" class="fi profile-flag" :class="'fi-' + client.address.country_code.toLowerCase()"></span>
                {{ client.address?.country_code || '—' }}
              </span>
            </div>
          </div>
        </div>

        <!-- Sekce: Ověření identity -->
        <div class="col-12 col-lg-6">
          <div class="dashboard-section-header mb-3">
            <div class="d-flex align-items-center gap-2">
              <img :src="iconSpecialOk" alt="" class="dashboard-section-header__icon">
              <span class="dashboard-section-header__title">{{ $t('client.verification') }}</span>
            </div>
            <button class="profile-edit-btn" @click="toggleVerificationModal">
              {{ $t('general.edit') }}<i class="bi bi-pencil-fill ms-1"></i>
            </button>
          </div>
          <div class="profile-data-card">
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.documentType') }}</span>
              <span class="cert-list__value">{{ client.verification?.document_type ? $t('client.' + client.verification.document_type) : '—' }}</span>
            </div>
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.documentNumber') }}</span>
              <span class="cert-list__value">{{ client.verification?.document_number || '—' }}</span>
            </div>
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('client.expirationDate') }}</span>
              <span class="cert-list__value">{{ client.verification?.expiration_date ? formatDate(client.verification.expiration_date) : '—' }}</span>
            </div>
          </div>
        </div>

      </div>

      <!-- Sekce: Předvolby -->
<!--      <div class="dashboard-section-header mb-3 mt-5">
        <div class="d-flex align-items-center gap-2">
          <i class="bi bi-globe2 profile-section-icon"></i>
          <span class="dashboard-section-header__title">{{ $t('client.preferences') }}</span>
        </div>
      </div>
      <div class="profile-data-card mb-5">
        <div class="profile-data-field">
          <span class="cert-list__label">{{ $t('client.language') }}</span>
          <div class="profile-lang-btns">
            <button
              type="button"
              class="profile-lang-btn"
              :class="{ 'profile-lang-btn&#45;&#45;active': currentLocale === 'cs' }"
              @click="changeLocale('cs')"
            >CS</button>
            <button
              type="button"
              class="profile-lang-btn"
              :class="{ 'profile-lang-btn&#45;&#45;active': currentLocale === 'en' }"
              @click="changeLocale('en')"
            >EN</button>
          </div>
        </div>
      </div>-->

      <!-- Sekce: Účet (bez ohraničení a pozadí) -->
      <div class="dashboard-section-header mb-3">
        <div class="d-flex align-items-center gap-2">
          <img :src="iconAccount" alt="" class="dashboard-section-header__icon profile-icon-muted">
          <span class="dashboard-section-header__title">{{ $t('client.account') }}</span>
        </div>
      </div>
      <div class="profile-account-row mb-5">
        <button class="btn cert-list__view-btn" @click="logout">
          {{ $t('client.logout') }}<img :src="iconLogout" alt="" class="profile-logout-icon ms-1">
        </button>
        <button v-if=false class="btn profile-delete-account-btn" @click="deleteAccount">
          {{ $t('client.deleteAccount') }}<img :src="iconTrash" alt="" class="profile-delete-account-btn__icon ms-2">
        </button>
      </div>

      <!-- Sekce: Referral (podmíněně) -->
      <div v-if="client?.allow_referral || client?.allow_referral_student">
        <div class="dashboard-section-header mb-3">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-link-45deg profile-section-icon"></i>
            <span class="dashboard-section-header__title">{{ $t('client.referralLink') }}</span>
          </div>
        </div>
        <div class="cert-list__row cert-detail__info-row mb-5">
          <div class="cert-list__col">
            <button id="copyLinkButton" @click="copyReferralLink" class="profile-referral-link">
              {{ appOrigin }}/register?referral={{ client.allow_referral ? client.referral_uuid : client.referral_student_uuid }}
            </button>
          </div>
        </div>
      </div>

      <!-- Sekce: Affiliate (podmíněně) -->
      <div v-if="client?.is_affiliate">
        <div class="dashboard-section-header mb-3">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-megaphone profile-section-icon"></i>
            <span class="dashboard-section-header__title">{{ $t('client.affiliateLink') }}</span>
          </div>
        </div>
        <div class="cert-list__row cert-detail__info-row mb-5">
          <div class="cert-list__col">
            <button id="copyAffiliateLinkButton" @click="copyAffiliateLink" class="profile-referral-link">
              {{ appOrigin }}/register/direct/{{ client.affiliate_token }}
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Modal: úprava kontaktních informací -->
    <transition name="page-fade">
      <div v-if="modalActive" class="create-cert-overlay" @click.self="toggleModal">
        <div class="create-cert-modal">
          <div class="create-cert-modal__header">
            <div class="create-cert-modal__header-left">
              <img :src="iconEnvelope" alt="" class="create-cert-modal__modal-icon">
              <span class="create-cert-modal__title">{{ $t('client.editPersonalInformation') }}</span>
            </div>
            <button class="create-cert-modal__close" type="button" @click="toggleModal" aria-label="Close">×</button>
          </div>
          <div class="create-cert-modal__body">
            <Form @submit="handleClientInformationFormSend" :validation-schema="formValidationSchema" ref="clientProfileEditForm">
              <label class="create-cert-label" for="salutation">{{ $t('client.salutation') }}</label>
              <Field type="text" class="create-cert-input mb-4" name="salutation" id="salutation" :placeholder="$t('client.salutation_placeholder')" v-model="clientForModal.salutation" />
              <label class="create-cert-label" for="name">{{ $t('client.name') }}<span class="text-danger ms-1">*</span></label>
              <Field type="text" class="create-cert-input mb-4" name="name" id="name" :placeholder="$t('client.name')" v-model="clientForModal.name" />
              <ErrorMessage class="text-danger small d-block mb-5" name="name" />
              <label class="create-cert-label" for="email">{{ $t('client.email') }}<span class="text-danger ms-1">*</span></label>
              <Field type="text" class="create-cert-input mb-4" name="email" id="email" placeholder="E-mail" v-model="clientForModal.email" />
              <ErrorMessage class="text-danger small d-block mb-5" name="email" />
              <div class="d-flex justify-content-center mt-5">
                <button type="submit" class="btn btn-primary profile-modal-btn">
                  <img :src="iconOk" alt="" class="profile-modal-save-icon">
                  {{ $t('general.saveChanges') }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal: úprava adresy -->
    <transition name="page-fade">
      <div v-if="modalAddressActive" class="create-cert-overlay" @click.self="toggleAddressModal">
        <div class="create-cert-modal">
          <div class="create-cert-modal__header">
            <div class="create-cert-modal__header-left">
              <img :src="iconHome" alt="" class="create-cert-modal__modal-icon icon-blue" style="filter: brightness(0) invert(24%) sepia(87%) saturate(5481%) hue-rotate(213deg) brightness(101%) contrast(106%)">
              <span class="create-cert-modal__title">{{ $t('client.editAddress') }}</span>
            </div>
            <button class="create-cert-modal__close" type="button" @click="toggleAddressModal" aria-label="Close">×</button>
          </div>
          <div class="create-cert-modal__body">
            <Form @submit="handleClientAddressFormSend" :validation-schema="formAddressValidationSchema" ref="clientAddressEditForm">
              <label class="create-cert-label" for="line_1">{{ $t('client.line1') }}<span class="text-danger ms-1">*</span></label>
              <Field type="text" class="create-cert-input mb-4" name="line_1" id="line_1" :label="$t('client.line1')" :placeholder="$t('client.line1')" v-model="clientForModal.address.line_1" />
              <ErrorMessage class="text-danger small d-block mb-5" name="line_1" />
              <label class="create-cert-label" for="line_2">{{ $t('client.line2') }} <span class="text-muted">{{ $t('client.optional') }}</span></label>
              <Field type="text" class="create-cert-input mb-4" name="line_2" id="line_2" :label="$t('client.line2')" :placeholder="$t('client.line2')" v-model="clientForModal.address.line_2" />
              <label class="create-cert-label" for="city">{{ $t('client.city') }}<span class="text-danger ms-1">*</span></label>
              <Field type="text" class="create-cert-input mb-4" name="city" id="city" :label="$t('client.city')" :placeholder="$t('client.city')" v-model="clientForModal.address.city" />
              <ErrorMessage class="text-danger small d-block mb-5" name="city" />
              <label class="create-cert-label" for="postal_code">{{ $t('client.postalCode') }}<span class="text-danger ms-1">*</span></label>
              <Field type="text" class="create-cert-input mb-4" name="postal_code" id="postal_code" :label="$t('client.postalCode')" :placeholder="$t('client.postalCode')" v-model="clientForModal.address.postal_code" />
              <ErrorMessage class="text-danger small d-block mb-5" name="postal_code" />
              <label class="create-cert-label" for="country_code">{{ $t('client.countryCode') }}</label>
              <div class="country-select mb-4" :class="{ 'country-select--open': countryDropdownOpen }">
                <div class="country-select__trigger create-cert-input" @click="openCountryDropdown">
                  <template v-if="clientForModal.address.country_code">
                    <span class="fi profile-flag" :class="'fi-' + clientForModal.address.country_code.toLowerCase()"></span>
                    <span>{{ countries.find(c => c.country_code === clientForModal.address.country_code)?.name }}</span>
                  </template>
                  <span v-else class="country-select__placeholder">{{ $t('client.chooseCountry') }}</span>
                  <i class="bi bi-chevron-down country-select__arrow"></i>
                </div>
                <div v-if="countryDropdownOpen" class="country-select__backdrop" @click="closeCountryDropdown"></div>
                <div v-if="countryDropdownOpen" class="country-select__dropdown">
                  <div class="country-select__search-wrap">
                    <i class="bi bi-search country-select__search-icon"></i>
                    <input
                      ref="countrySearchInput"
                      type="text"
                      class="country-select__search-input"
                      :placeholder="$t('client.searchCountry')"
                      v-model="countrySearch"
                      @click.stop
                    />
                  </div>
                  <template v-for="(country, index) in filteredCountries" :key="country.country_code">
                    <div
                      v-if="!countrySearch && index > 0 && !country.pinned && filteredCountries[index - 1].pinned"
                      class="country-select__divider"
                    ></div>
                    <div
                      class="country-select__option"
                      :class="{ 'country-select__option--active': clientForModal.address.country_code === country.country_code }"
                      @click="selectCountry(country.country_code)"
                    >
                      <span class="fi profile-flag" :class="'fi-' + country.country_code.toLowerCase()"></span>
                      <span>{{ country.name }}</span>
                    </div>
                  </template>
                </div>
              </div>
              <div class="d-flex justify-content-center mt-5">
                <button type="submit" class="btn btn-primary profile-modal-btn">
                  <img :src="iconOk" alt="" class="profile-modal-save-icon">
                  {{ $t('general.saveChanges') }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal: ověření identity -->
    <transition name="page-fade">
      <div v-if="modalVerificationActive" class="create-cert-overlay" @click.self="toggleVerificationModal">
        <div class="create-cert-modal">
          <div class="create-cert-modal__header">
            <div class="create-cert-modal__header-left">
              <img :src="iconSpecialOk" alt="" class="create-cert-modal__modal-icon" style="filter: brightness(0) invert(24%) sepia(87%) saturate(5481%) hue-rotate(213deg) brightness(101%) contrast(106%)">
              <span class="create-cert-modal__title">{{ $t('client.editID') }}</span>
            </div>
            <button class="create-cert-modal__close" type="button" @click="toggleVerificationModal" aria-label="Close">×</button>
          </div>
          <div class="create-cert-modal__body">
            <Form @submit="handleClientVerificationFormSend" :validation-schema="formVerificationValidationSchema" ref="clientVerificationEditForm">
              <label class="create-cert-label" for="document_type">{{ $t('client.documentType') }}<span class="text-danger ms-1">*</span></label>
              <div class="select-wrap mb-4">
              <Field as="select" class="create-cert-input create-cert-input--select" name="document_type" id="document_type" v-model="clientForModal.verification.document_type">
                <option value="" disabled>{{ $t('client.chooseDocumentType') }}</option>
                <option v-for="type in documentTypeOptions" :key="type.value" :label="type.name" :value="type.value"></option>
              </Field>
              </div>
              <label class="create-cert-label" for="document_number">{{ $t('client.documentNumber') }}<span class="text-danger ms-1">*</span></label>
              <Field type="text" class="create-cert-input mb-4" name="document_number" id="document_number" :placeholder="$t('client.documentNumber')" v-model="clientForModal.verification.document_number" />
              <label class="create-cert-label" for="expiration_date">{{ $t('client.expirationDate') }}<span class="text-danger ms-1">*</span></label>
              <input type="date" class="create-cert-input mb-4" id="expiration_date" name="expiration_date" v-model="clientForModal.verification.expiration_date" />
              <div class="d-flex justify-content-center mt-5">
                <button type="submit" class="btn btn-primary profile-modal-btn">
                  <img :src="iconOk" alt="" class="profile-modal-save-icon">
                  {{ $t('general.saveChanges') }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal: změna hesla -->
    <transition name="page-fade">
      <div v-if="modalPasswordActive" class="create-cert-overlay" @click.self="togglePasswordModal">
        <div class="create-cert-modal">
          <div class="create-cert-modal__header">
            <div class="create-cert-modal__header-left">
              <img :src="iconLock" alt="" class="create-cert-modal__modal-icon">
              <span class="create-cert-modal__title">{{ $t('client.passwordChange') }}</span>
            </div>
            <button class="create-cert-modal__close" type="button" @click="togglePasswordModal" aria-label="Close">×</button>
          </div>
          <div class="create-cert-modal__body">
            <Form @submit="handleClientPasswordChangeFormSend" :validation-schema="formPasswordChangeValidationSchema" ref="clientPasswordChangeForm">
              <label class="create-cert-label" for="password">{{ $t('client.newPassword') }}<span class="text-danger ms-1">*</span></label>
              <Field type="password" class="create-cert-input mb-4" name="password" id="password" v-model="password" :label="$t('client.password')" />
              <ErrorMessage class="text-danger small d-block mb-5" name="password" />
              <label class="create-cert-label" for="password_confirmation">{{ $t('client.newPasswordConfirmation') }}<span class="text-danger ms-1">*</span></label>
              <Field type="password" class="create-cert-input mb-4" name="password_confirmation" id="password_confirmation" v-model="password_confirmation" :label="$t('client.passwordConfirmation')" />
              <ErrorMessage class="text-danger small d-block mb-5" name="password_confirmation" />
              <div class="d-flex justify-content-center mt-5">
                <button type="submit" class="btn btn-primary profile-modal-btn">
                  <img :src="iconOk" alt="" class="profile-modal-save-icon">
                  {{ $t('general.saveChanges') }}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import axios from 'axios';
import http from '@/http';
import { loadingState } from '@/loading.js';
import iconHome from '/public/img/new-design/icons/home.svg';
import iconSpecialOk from '/public/img/new-design/icons/special-ok-icon.svg';
import iconTrash from '/public/img/new-design/icons/trash.svg';
import iconAccount from '/public/img/new-design/icons/account.svg';
import iconLogout from '/public/img/new-design/icons/logout.svg';
import iconLock from '/public/img/new-design/icons/lock.svg';
import iconOk from '/public/img/new-design/icons/ok.svg';
import iconEnvelope from '/public/img/new-design/icons/envelope.svg';

const EMPTY_CLIENT = {
  name: '',
  salutation: '',
  email: '',
  address: {
    line_1: '',
    line_2: '',
    city: '',
    country_code: '',
    postal_code: '',
  },
  verification: {
    document_type: '',
    document_number: '',
    expiration_date: '',
  },
};

export default {
  mounted() {
    this.getAuthClient();
    this.getCountries();
    let self = this;
    self.clientForModal = { ...EMPTY_CLIENT };
    if (self.clientForModal.address == null) {
      self.clientForModal.address = { ...EMPTY_CLIENT.address };
    }
  },

  data() {
    return {
      appOrigin: window.location.origin,
      client: {
        name: '',
        salutation: '',
        email: '',
        address: {
          line_1: '',
          line_2: '',
          city: '',
          country_code: '',
          postal_code: '',
        },
        verification: {
          document_type: '',
          document_number: '',
          expiration_date: '',
        },
      },
      password: '',
      password_confirmation: '',
      countries: [],
      countryDropdownOpen: false,
      countrySearch: '',
      modalActive: false,
      modalAddressActive: false,
      modalVerificationActive: false,
      modalPasswordActive: false,
      clientForModal: {
        address: {
          line_1: '',
          line_2: '',
          city: '',
          country_code: '',
          postal_code: '',
        },
        verification: {
          document_type: '',
          document_number: '',
          expiration_date: '',
        },
      },
      documentTypeOptions: [
        { name: this.$t('client.IDENTITY_CARD'), value: 'IDENTITY_CARD' },
        { name: this.$t('client.DRIVER_LICENCE'), value: 'DRIVER_LICENCE' },
        { name: this.$t('client.PASSPORT'), value: 'PASSPORT' },
      ],
      formValidationSchema: {
        name: 'required|min:5',
        email: 'required|email',
      },
      formAddressValidationSchema: {
        line_1: 'required|min:3',
        city: 'required',
        country_code: '',
        postal_code: 'required',
      },
      formVerificationValidationSchema: {
        document_type: '',
        document_number: '',
        expiration_date: '',
      },
      formPasswordChangeValidationSchema: {
        password: 'required|min:8',
        password_confirmation: 'required|min:8|confirmed:@password',
      },
      isLoading: true,
      currentLocale: localStorage.getItem('lang') || document.documentElement.lang || 'cs',
      iconHome,
      iconSpecialOk,
      iconTrash,
      iconAccount,
      iconLogout,
      iconLock,
      iconOk,
      iconEnvelope,
    };
  },

  computed: {
    initials() {
      if (!this.client.name) return '?';
      return this.client.name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');
    },

    isName() {
      return this.client.name && this.client.name.length !== 0;
    },

    isAddress() {
      return this.client.address.line_1.length !== 0 && this.client.address.city.length !== 0 && this.client.address.postal_code.length !== 0;
    },

    filteredCountries() {
      if (!this.countrySearch) return this.countries;
      const q = this.countrySearch.toLowerCase();
      return this.countries.filter(c => c.name.toLowerCase().includes(q));
    },

    isAllVerificationData() {
      return this.client.verification && this.client.verification.document_type?.length !== 0 && this.client.verification.document_number?.length !== 0 && this.client.verification.expiration_date?.length !== 0;
    },
  },

  methods: {
    getAuthClient() {
      let self = this;
      self.isLoading = true;
      http.get('/get-auth-client').then((response) => {
        self.client = response.data.client;
        if (!response.data.client.address) {
          self.client.address = { ...EMPTY_CLIENT.address };
        }
        if (!response.data.client.verification) {
          self.client.verification = { ...EMPTY_CLIENT.verification };
        }
        self.clientForModal = JSON.parse(JSON.stringify(self.client));
        self.isLoading = false;
        loadingState.active = false;
      });
    },

    getCountries() {
      let self = this;
      http.get('/countries').then((response) => {
        self.countries = response.data.countries;
      });
    },

    editClientInformation() {
      let self = this;
      let body = {
        name: this.clientForModal.name,
        salutation: this.clientForModal.salutation || null,
        email: this.clientForModal.email,
      };
      http.post('/profile/' + self.client.uuid + '/edit', body).then((response) => {
        self.client = response.data.client;
        if (!response.data.client.address) {
          self.client.address = { ...EMPTY_CLIENT.address };
        }
        if (!response.data.client.verification) {
          self.client.verification = { ...EMPTY_CLIENT.verification };
        }
        self.toggleModal();
      });
    },

    editClientAddress() {
      let self = this;
      let body = {
        line_1: this.clientForModal.address.line_1,
        line_2: this.clientForModal.address.line_2,
        city: this.clientForModal.address.city,
        country_code: this.clientForModal.address.country_code ? this.clientForModal.address.country_code : 'CZ',
        postal_code: this.clientForModal.address.postal_code,
      };
      http.post('/address/' + self.client.uuid + '/edit', body).then((response) => {
        self.client = response.data.client;
        self.toggleAddressModal();
      });
    },

    editClientVerification() {
      let self = this;
      let body = {
        document_type: this.clientForModal.verification.document_type ? this.clientForModal.verification.document_type : 'OP',
        document_number: this.clientForModal.verification.document_number,
        expiration_date: this.clientForModal.verification.expiration_date,
      };
      http.post('/profile/verification/' + self.client.uuid + '/edit', body).then((response) => {
        self.client = response.data.client;
        if (!response.data.client.address) {
          self.client.address = { ...EMPTY_CLIENT.address };
        }
        self.toggleVerificationModal();
      });
    },

    updatePassword() {
      let self = this;
      let body = {
        password: this.password,
        password_confirmation: this.password_confirmation,
      };
      http.post('/password/' + self.client.uuid + '/change', body).then(() => {});
      self.togglePasswordModal();
    },

    handleClientPasswordChangeFormSend() {
      this.updatePassword();
    },

    handleClientInformationFormSend() {
      this.editClientInformation();
    },

    handleClientAddressFormSend() {
      this.editClientAddress();
    },

    handleClientVerificationFormSend() {
      this.editClientVerification();
    },

    toggleModal() {
      this.modalActive = !this.modalActive;
      document.body.style.overflow = this.modalActive ? 'hidden' : '';
      if (this.modalActive) this.clientForModal = JSON.parse(JSON.stringify(this.client));
    },

    openCountryDropdown() {
      this.countryDropdownOpen = true;
      this.$nextTick(() => {
        if (this.$refs.countrySearchInput) this.$refs.countrySearchInput.focus();
      });
    },

    closeCountryDropdown() {
      this.countryDropdownOpen = false;
      this.countrySearch = '';
    },

    selectCountry(code) {
      this.clientForModal.address.country_code = code;
      this.closeCountryDropdown();
    },

    toggleAddressModal() {
      this.modalAddressActive = !this.modalAddressActive;
      document.body.style.overflow = this.modalAddressActive ? 'hidden' : '';
      if (this.modalAddressActive) this.clientForModal = JSON.parse(JSON.stringify(this.client));
      if (!this.modalAddressActive) this.closeCountryDropdown();
    },

    toggleVerificationModal() {
      this.modalVerificationActive = !this.modalVerificationActive;
      document.body.style.overflow = this.modalVerificationActive ? 'hidden' : '';
      if (this.modalVerificationActive) this.clientForModal = JSON.parse(JSON.stringify(this.client));
    },

    togglePasswordModal() {
      this.modalPasswordActive = !this.modalPasswordActive;
      document.body.style.overflow = this.modalPasswordActive ? 'hidden' : '';
      if (!this.modalPasswordActive && this.$refs.clientPasswordChangeForm) {
        this.$refs.clientPasswordChangeForm.resetForm();
      }
    },

    changeLocale(lang) {
      http.post('/set-locale', { locale: lang }).then(() => {
        localStorage.setItem('lang', lang);
        location.reload();
      });
    },

    logout() {
      axios.post('/logout').then(() => {
        window.location.href = '/';
      });
    },

    deleteAccount() {
      this.$swal.fire({
        title: this.$t('client.deleteAccount'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#6c757d',
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
      }).then((result) => {
        if (result.isConfirmed) {
          http.post('/profile/' + this.client.uuid + '/delete').then(() => {
            window.location.href = '/';
          });
        }
      });
    },

    copyTextToClipboard(text) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text);
      }

      // Fallback pro non-secure kontext (http://), kde Clipboard API není k dispozici.
      return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        const successful = document.execCommand('copy');
        document.body.removeChild(textarea);

        successful ? resolve() : reject();
      });
    },

    copyReferralLink() {
      const text = document.getElementById('copyLinkButton').innerText;
      this.copyTextToClipboard(text).then(() => {
        alert('Odkaz byl zkopírován do schránky.');
      }).catch(() => {
        alert('Nepodařilo se zkopírovat odkaz.');
      });
    },

    copyAffiliateLink() {
      const text = document.getElementById('copyAffiliateLinkButton').innerText;
      this.copyTextToClipboard(text).then(() => {
        alert('Odkaz byl zkopírován do schránky.');
      }).catch(() => {
        alert('Nepodařilo se zkopírovat odkaz.');
      });
    },

    countryFlag(code) {
      if (!code || code.length !== 2) return '';
      return Array.from(code.toUpperCase())
        .map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65))
        .join('');
    },

    formatDate(date) {
      let d = new Date(date);
      return (
        ('00' + d.getDate()).slice(-2) + '. ' +
        ('00' + (d.getMonth() + 1)).slice(-2) + '. ' +
        d.getFullYear()
      );
    },
  },
};
</script>